/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum FaceEventsFeaturesEnum {
    AGE = 'age',
    GENDER = 'gender',
    EMOTIONS = 'emotions',
    BEARD = 'beard',
    GLASSES = 'glasses',
    MEDMASK = 'medmask',
    HEADPOSE = 'headpose',
    EYES_ATTRS = 'eyes_attrs',
}